<template>
  <div class="row g-0">
    <div class="col-8">
      <search-content-review
        @listenTransferNumber="listenTransferNumber"
        class="search"
      />
      <vue-good-table
        class="vue-table"
        ref="table"
        :key="tableKey"
        @row-click="onRowClick"
        @page-change="onPageChange"
        @sort-change="onSortChange"
        @column-filter="onColumnFilter"
        @per-page-change="onPerPageChange"
        :isLoading.sync="isLoading"
        :pagination-options="paginationOptions"
        :totalRows="contentStore.totalRecords"
        :rows="contentStore.contents"
        :columns="paginationData.columns"
      >
        <template #table-actions-bottom>
          <pagination-records
            :pages="serverParams.page"
            :per-page="serverParams.perPage"
            :total="contentStore.totalRecords"
          />
        </template>
        <template #table-row="props">
          <!-- <span v-if="props.column.field == 'timeTaken'">
            <span
              v-if="
                props.row.timeTaken == null &&
                props.row.id == contentStore.currentContent?.id
              "
              ><span style="font-weight: bold; color: blue">-</span>
            </span>
            <span
              v-else-if="
                props.row.timeTaken == null &&
                props.row.id != contentStore.currentContent?.id
              "
              >-
            </span>
            <span
              v-else-if="
                props.row.timeTaken != null &&
                props.row.id == contentStore.currentContent?.id
              "
              ><span style="font-weight: bold; color: blue">{{
                props.formattedRow[props.column.field]
              }}</span>
            </span>
            <span v-else>{{ props.formattedRow[props.column.field] }}</span>
          </span>
          <span v-else-if="props.row.id == contentStore.currentContent?.id"> -->
          <span v-if="props.row.id == contentStore.currentContent?.id">
            <span style="font-weight: bold; color: blue">{{
              props.formattedRow[props.column.field]
            }}</span></span
          >
          <span v-else>{{ props.formattedRow[props.column.field] }}</span>
        </template>
      </vue-good-table>
    </div>
    <div class="col-4">
      <span id="batchLayout" class="border-start">
        <batch-layout />
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import GlobalData from "@/GlobalData";
import BatchLayout from "@/components/ContentReview/Layout/BatchLayout.vue";
import SearchContentReview from "@/components/ContentReview/SearchContentReview.vue";
import PaginationRecords from "@/components/Pagination/PaginationRecords.vue";
import { formatTimeTaken } from "@/composables/useDateConversion";
import { useSortConversion } from "@/composables/useStringConversion";
import { useContentStore } from "@/stores/content_review/content";
import { useTransferStore } from "@/stores/content_review/transfer";
import { useAsyncState } from "@vueuse/core";
import moment from "moment";
import { ref, watch, onMounted } from "vue";

onMounted(() => {
  GlobalData.getInstance().changeBatchPosition = changeBatchPosition;
});

const tableKey = ref(0);
const table = ref();
const contentStore = useContentStore();
const transferStore = useTransferStore();
const isLoading = ref(false);

const forceRerender = () => {
  tableKey.value += 1;
};

watch(
  () => contentStore.loading,
  (updateLoading) => (isLoading.value = updateLoading)
);

watch(
  () => transferStore.loading,
  (updateLoading) => (isLoading.value = updateLoading)
);

watch(
  () => contentStore.contents,
  (updateContent) => {
    if (updateContent[0] == null) {
      contentStore.totalRecords = 0;
      isLoading.value = false;
    }
  }
);

const paginationOptions = ref({
  enabled: true,
  mode: "pages",
  position: "bottom",
  perPageDropdown: [10, 20, 30, 50],
  perPage: contentStore.currentPerPage,
  setCurrentPage: contentStore.currentPage,
  dropdownAllowAll: true,
});

const serverParams = ref({
  columnFilters: [
    { fieldName: "id", filterText: contentStore.currentFilters[0].filterText },
    {
      fieldName: "transferring_agency",
      filterText: contentStore.currentFilters[1].filterText,
    },
    {
      fieldName: "status",
      filterText: contentStore.currentFilters[2].filterText,
    },
    {
      fieldName: "content_type",
      filterText: contentStore.currentFilters[3].filterText,
    },
    {
      fieldName: "status_updated_at",
      filterText: contentStore.currentFilters[4].filterText,
    },
  ],
  sort: { field: "id", type: "desc" },
  page: contentStore.currentPage,
  perPage: contentStore.currentPerPage,
  currentContentId: contentStore.currentContentId,
});

let paginationData = {
  totalRecords: contentStore.totalRecords,
  columns: [
 
    { label: "Content Type", field: "contentType" },
    { label: "Package Name", field: "name" },
    {
      label: "Batch No.",
      field: function (rowObj) {
        return rowObj.number ? rowObj.number : "-";
      },
    },
    {
      label: "Time Started",
      field: "depositedAt",
      formatFn: function (value: any) {
        return moment(new Date(value)).format("DD MMMM yyyy HH:mm:ss");
      },
    },
    {
      label: "Time Taken",
      field: formatTimeTaken,
      // field: "timeTaken",
      // formatFn: function (value) {
      //   return value ? value + "s" : value;
      // },
    },
    {
      label: "Batch Status Date",
      field: "statusUpdatedAt",
      formatFn: function (value: any) {
        return moment(new Date(value)).format("DD MMMM yyyy HH:mm:ss");
      },
    },
    { label: "Batch Status", field: "status" },
    { label: "Transfer UUID", 
    field: function (rowObj) {
        return rowObj.contentId ? rowObj.contentId : "-";
      },sortable: false, },
  ],
};

const { execute } = useAsyncState(() => {
  return contentStore.fetchContents(
    serverParams.value.perPage,
    useSortConversion(serverParams.value.sort) as string,
    serverParams.value.columnFilters as Array<object>,
    serverParams.value.page as number,
    serverParams.value.currentContentId as number
  );
}, null);

const updateParams = (newProps: any) => {
  serverParams.value = Object.assign({}, serverParams.value, newProps);
};

const changeBatchPosition = (remove, add) => {
  let batchLayout: any = document.getElementById("batchLayout");
  batchLayout.classList.remove(remove);
  batchLayout.classList.add(add);
};

const onPageChange = (params) => {
  //--START --use for showing xx-xx  of xxx records
  updateParams({
    perPage: params.currentPerPage,
    page: params.currentPage,
    currentContentId: 0,
  });
  //--END--
  contentStore.storeCurrentPage(params.currentPage);
  contentStore.fetchCurrent(table.value.paginated[0].children[0], 1);
};

const onPerPageChange = (params) => {
  updateParams({
    perPage: params.currentPerPage,
    page: 1,
    currentContentId: 0,
  });
  contentStore.storeCurrentPerPage(params.currentPerPage);
  contentStore.fetchCurrent(table.value.originalRows[0].children[0], 1);
};

const onSortChange = (params) => {
  updateParams({
    page: 1,
  });
  //setTimeout because cannot grab data fast enough
  // isLoading.value = true;
  setTimeout(() => {
    contentStore.fetchCurrent(table.value.filteredRows[0].children[0], 1)
    // isLoading.value = false;
  }, 500);
  //
};

const onColumnFilter = (params) => {
  contentStore.contents = [];
  forceRerender();
  table.value.reset();
  updateParams({
    sort: { type: "desc", field: "id" },
    page: 1,
    currentContentId: 0,
  });
  paginationOptions.value.setCurrentPage = 1;
  execute();
};

const onRowClick = (params) => {
  // updateParams({
  //   currentContentId: params.pageIndex,
  // });
  contentStore.fetchCurrent(params.row, params.pageIndex);
};

const listenTransferNumber = (inputParams) => {
  serverParams.value.columnFilters = serverParams.value.columnFilters.map(
    (obj) =>
      obj.fieldName === "id"
        ? { ...obj, filterText: inputParams.transferNo }
        : obj
  );
  serverParams.value.columnFilters = serverParams.value.columnFilters.map(
    (obj) =>
      obj.fieldName === "transferring_agency"
        ? { ...obj, filterText: inputParams.transferAgency }
        : obj
  );
  serverParams.value.columnFilters = serverParams.value.columnFilters.map(
    (obj) =>
      obj.fieldName === "status"
        ? { ...obj, filterText: inputParams.batchStatus }
        : obj
  );
  serverParams.value.columnFilters = serverParams.value.columnFilters.map(
    (obj) =>
      obj.fieldName === "content_type"
        ? { ...obj, filterText: inputParams.contentType }
        : obj
  );
  serverParams.value.columnFilters = serverParams.value.columnFilters.map(
    (obj) =>
      obj.fieldName === "status_updated_at"
        ? { ...obj, filterText: inputParams.batchStatusDate }
        : obj
  );
  onColumnFilter(serverParams);
};
</script>
<style scoped>
.vue-table {
  margin: 16px;
  padding-right: 30px;
  width: 100%;
}
.search {
  padding-right: 30px;
  margin: 16px;
  margin-top: 0;
  width: 100%;
}
.batch-layout {
  /* used to change style when modal is active */
  position: relative;
  overflow: auto;
  height: 100%;
}
.border-start {
  position: fixed;
  top: 60px;
  overflow: auto;
  height: 100%;
}
</style>
